module.exports = __webpack_public_path__ + "6b11090bbbb33573bcb26d36a747db20.png";